import ContentLoader from 'react-content-loader';
import *as React from 'react';

export class DiaryListViewLeftPanelListingLoader extends React.PureComponent{
    constructor(props){
        super(props);
    }
    render(){
        const returnLoader = [<LoaderComponent key={0} />];
        if(this.props.count && this.props.count > 0){
            var i;
            for (i = 0; i < this.props.count; i++) {
                returnLoader.push(<LoaderComponent key={i+1} />)
            }
        }
        return returnLoader;
      
    }
}

const LoaderComponent = ({key}) => {
    return(
        <div key={key}  style={{height:"330px", backgroundColor:"#fff"}}>
            <ContentLoader 
                speed={2}
                width={960}
                height={330}
                viewBox="0 0 960 330"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
            >
                <rect x="20" y="30" rx="0" ry="0" width="920" height="3" /> 
                <rect x="370" y="20" rx="15" ry="15" width="151" height="20" /> 

                <rect x="20" y="60" rx="0" ry="0" width="400" height="12" /> 
                <rect x="650" y="60" rx="0" ry="0" width="200" height="12" /> 
                <rect x="20" y="90" rx="0" ry="0" width="96" height="24" /> 
                <rect x="125" y="90" rx="0" ry="0" width="96" height="24" /> 
                <rect x="230" y="90" rx="0" ry="0" width="96" height="24" /> 

                <rect x="20" y="150" rx="0" ry="0" width="400" height="12" /> 
                <rect x="20" y="180" rx="0" ry="0" width="96" height="24" /> 
                <rect x="125" y="180" rx="0" ry="0" width="96" height="24" /> 
                <rect x="230" y="180" rx="0" ry="0" width="96" height="24" /> 
                <rect x="650" y="150" rx="0" ry="0" width="200" height="12"/> 
                
                <rect x="20" y="240" rx="0" ry="0" width="400" height="12"/> 
                <rect x="20" y="270" rx="0" ry="0" width="96" height="24"/> 
                <rect x="125" y="270" rx="0" ry="0" width="96" height="24"/> 
                <rect x="230" y="270" rx="0" ry="0" width="96" height="24"/> 
                <rect x="650" y="240" rx="0" ry="0" width="200" height="12"/> 

                <rect x="20" y="330" rx="0" ry="0" width="400" height="12"/> 
                <rect x="650" y="330" rx="0" ry="0" width="200" height="12"/> 
                <rect x="20" y="360" rx="0" ry="0" width="96" height="24"/> 
                <rect x="125" y="360" rx="0" ry="0" width="96" height="24" /> 
                <rect x="230" y="360" rx="0" ry="0" width="96" height="24" />
            </ContentLoader>
        </div>
    )}
